module.exports = __webpack_public_path__ + "static/media/consultationPppCs.a87a5a0c.jpg";